import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

const toastError = err => {
	// ✅ CORREÇÃO: Verificar tanto 'error' quanto 'message' no response
	const errorMsg = err.response?.data?.error || err.response?.data?.message;
	
	if (errorMsg) {
		// Extrai o código ERR_* mesmo quando o backend acrescenta sufixo
		// (ex.: "ERR_NO_DEF_WAPP_FOUND in COMPANY 2")
		const errorCodeMatch = String(errorMsg).match(/^(ERR_[A-Z0-9_]+)/);
		const errorCode = errorCodeMatch ? errorCodeMatch[1] : errorMsg;

		const translationPath = `backendErrors.${errorCode}`;
		
		let translatedMessage = null;
		try {
			translatedMessage = i18n.t(translationPath, { defaultValue: null });
			
			if (!translatedMessage || translatedMessage === translationPath) {
				translatedMessage = null;
			}
		} catch (e) {
			translatedMessage = null;
		}
		
		const messageToShow = translatedMessage || errorMsg;
		
		toast.error(messageToShow, {
			toastId: errorCode,
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "light",
			style: {
				zIndex: 10004
			}
		});
		return
	} if (isString(err)) {
		toast.error(err, {
			style: {
				zIndex: 10004
			}
		});
		return
	} else {
		toast.error("Ocorreu um erro!", {
			style: {
				zIndex: 10004
			}
		});
		return
	}
};

export default toastError;
